<script setup>
import { ref, defineProps, defineEmits } from "vue";

// Structure of chartData
// labels = Array of strings ["TestLabel1", "TestLabel2", "TestLabel3"]
// values = Array of numbers [44, 55, 13]
// Data = Array of objects containing data for each data point. clickDataPoint
// event will return the object for the clicked data point.
const props = defineProps({
  labels: Array,
  values: Array,
  data: Array,
  additionalData: Object,
  height: Number,
  width: Number,
});

const emit = defineEmits(["clickDataPoint"]);

function clickHandler(event, chartContext, config) {
  if (props.data?.length >= config.dataPointIndex) {
    const data = props.data[config.dataPointIndex];
    emit("clickDataPoint", data, config);
  } else {
    emit("clickDataPoint", null, config);
  }
}

const chart = ref({
  //options: {
  chart: { type: "pie" },
  // plotOptions: { pie: { customScale: 0.5 } },
  labels: props.labels,
  // TODO: Add j24ChartData to the chartData object?
  j24ChartData: props.data,
  j24AdditionalData: props.additionalData,
  colors: ["#eb5d0b", "#7b264b", "#374f50", "#abb9c2", "#eeeeee"],
  dataLabels: {
    style: {
      colors: ["#111111"],
    },
    formatter: function (val, opts) {
      return opts.w.config.series[opts.seriesIndex];
    },
    dropShadow: {
      enabled: false,
      top: 1,
      left: 1,
      blur: 1,
      color: "#000",
      opacity: 0.45,
    },
  },
  //},
  series: props.values,
  states: {
    active: {
      filter: {
        type: "none",
      },
    },
  },
});
</script>

<template>
  <apexchart
    v-if="props.labels?.length > 0 && props.values?.length > 0"
    class=""
    :options="chart"
    :series="chart.series"
    @dataPointSelection="clickHandler"
    height="115%"
  />
</template>
